import React, { useState, useEffect } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { useAuth } from '../../../contexts/AuthContext';
import MedicalForm from './MedicalForm';
import { Edit, X } from 'lucide-react';

const MedicalSection = ({ db, onComplete }) => {
  const { user } = useAuth();
  const [medical, setMedical] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMedical = async () => {
      try {
        const pilotRef = doc(db, 'pilot', user.uid);
        const docSnap = await getDoc(pilotRef);
        if (docSnap.exists() && docSnap.data().medical) {
          setMedical(docSnap.data().medical);
        }
      } catch (err) {
        console.error('Error loading medical information:', err);
        setError('Failed to load medical certificate.');
      } finally {
        setLoading(false);
      }
    };
    loadMedical();
  }, [db, user]);

  const handleRemove = async () => {
    try {
      const pilotRef = doc(db, 'pilot', user.uid);
      await updateDoc(pilotRef, { medical: null });
      setMedical(null);
    } catch (err) {
      console.error('Error removing medical information:', err);
      setError('Failed to remove medical certificate.');
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <div className="space-y-4">
      {editing ? (
        <MedicalForm
          initialData={medical}
          onSubmit={(updatedMedical) => {
            setMedical(updatedMedical);
            setEditing(false); // Return to view mode
          }}
          onCancel={() => setEditing(false)} // Return to view mode on cancel
        />
      ) : (
        <div className="p-4 border rounded-lg space-y-2">
          <p><strong>Class:</strong> {medical?.class || 'Not Provided'}</p>
          <p><strong>Issue Date:</strong> {medical?.issueDate ? new Date(medical.issueDate).toLocaleDateString('en-US') : 'Not Provided'}</p>
          <p><strong>Expiration Date:</strong> {medical?.expiryDate ? new Date(medical.expiryDate).toLocaleDateString('en-US') : 'Not Provided'}</p>
          <p><strong>AME Name:</strong> {medical?.examiner || 'Not Provided'}</p>
          <p><strong>Restrictions:</strong> {medical?.restrictions || 'None'}</p>

          <div className="flex space-x-2 mt-4">
            <button
              onClick={() => setEditing(true)}
              className="text-blue-500 hover:text-blue-700"
            >
              <Edit className="w-4 h-4" />
            </button>
            <button
              onClick={handleRemove}
              className="text-red-500 hover:text-red-700"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MedicalSection;
